/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />

/* tslint:disable:no-unused-variable member-ordering */

namespace API.Client {
    'use strict';

    export class DefaultApi {
        protected basePath = '/proxy/oag/gtw_rh'; 
        public defaultHeaders : any = {};

        static $inject: string[] = ['$http', '$httpParamSerializer'];

        constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
            if (basePath) {
                this.basePath = basePath;
            }
        }

        private extendObj<T1,T2>(objA: T1, objB: T2) {
            for(let key in objB){
                if(objB.hasOwnProperty(key)){
                    objA[key] = objB[key];
                }
            }
            return <T1&T2>objA;
        }

        /**
         * 
         * Retrieve open contracts using the receiptId as parameter\n
         * @param documentNumber The receiptId
         */
        public agenciesDocumentNumberGet (documentNumber: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<AgencyReponse> {
            const localVarPath = this.basePath + '/agencies/{documentNumber}'
                .replace('{' + 'documentNumber' + '}', String(documentNumber));

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'documentNumber' is set
            if (!documentNumber) {
                throw new Error('Missing required parameter documentNumber when calling agenciesDocumentNumberGet');
            }
            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
        /**
         * 
         * Retrieve open contracts using the receiptId as parameter\n
         * @param agencyData Agency data to be registered
         */
        public agenciesPost (agencyData: AgencyModel, extraHttpRequestParams?: any ) : ng.IHttpPromise<string> {
            const localVarPath = this.basePath + '/agencies';

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'agencyData' is set
            if (!agencyData) {
                throw new Error('Missing required parameter agencyData when calling agenciesPost');
            }
            let httpRequestParams: any = {
                method: 'POST',
                url: localVarPath,
                json: true,
                data: agencyData,
                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
    }
}
